import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  Table,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PreviewDocsDownload from "../PreviewDocsDownload";
import { styled } from "@mui/material/styles";
import JsFileDownloader from "js-file-downloader";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { getNextInvoice } from "../../services/httpCalls";
import DownloadIcon from "@mui/icons-material/Download";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import useNotify from "../../utils/useNotify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",

  boxShadow: 24,
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: ".5rem",
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: ".5rem",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
function InitialInvoiceModal({ open, handleClose, orgDetails }) {

const [doc, setDoc] = useState();
  const notify = useNotify();


  const cols = [
    {
      colName: "File Name",
      colId: "file name",
    },
    {
      colName: "File Type",
      colId: "file type",
    },
    {
      colName: "Preview",
      colId: "preview",
    },
    {
      colName: "Download",
      colId: "download",
    }
  ];

  const extension = (fileName) => {
    return fileName?.endsWith("zip");
  };

  useEffect(() => {
        if(orgDetails?.nextInvoiceUrl){
        const fileName = orgDetails.nextInvoiceUrl.toString().split('.com/')[1];
        getNextInvoice(fileName)
        .then((res) => {
            setDoc(res)
        })
    }
  },[orgDetails])

  return (
    <Box>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              p: 1,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            >
              View Files
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              marginBottom: "20px",
              paddingBottom: 2,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            ></Typography>

            <Box p={2}>
              {doc && Object.keys(doc).length ? (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{
                      maxHeight: "340px",
                    }}
                  >
                    <Table
                      stickyHeader
                      sx={{
                        minWidth: 350,
                        overflowY: "scroll",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          {cols?.map((cols, i) => {
                            return (
                              <StyledTableCell key={i} align="center">
                                {cols.colName}
                              </StyledTableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                            <StyledTableRow >
                              <StyledTableCell
                                sx={{
                                  width: "180px",
                                }}
                                align="center"
                              >
                                {doc.fileName.match(/~~(.+)/)[1]}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {doc.fileName.match(/~~(.+)/)[1].split('.')[1]}
                              </StyledTableCell>
                              {false ? (
                                <StyledTableCell align="center">
                                  No Preview
                                </StyledTableCell>
                              ) : (
                                <StyledTableCell align="center">
                                  <IconButton>
                                    <PreviewDocsDownload
                                      url={doc.preSignedUrl}
                                    />
                                  </IconButton>
                                </StyledTableCell>
                              )}

                              <StyledTableCell align="center">
                                <IconButton
                                  onClick={() => {
                                    new JsFileDownloader({
                                    url: doc.preSignedUrl,
                                    filename: doc.fileName.match(/~~(.+)/)[1].toString()
                                    })
                                      .then((res) => {
                                        notify.success("Download Success!");
                                      })
                                      .catch((err) => {
                                        console.log(err)
                                        notify.error("Download Failed!");
                                      });
                                  }}
                                >
                                  <DownloadIcon
                                    sx={{
                                      color: "#1876D1",
                                    }}
                                  />
                                </IconButton>
                              </StyledTableCell>
                            </StyledTableRow>
                           {/* );
                         })} */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Box
                  sx={{
                    padding: "3rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <AutoStoriesIcon
                    sx={{
                      fontSize: "100px",
                      color: "#DDE0E4",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      color: "#DDE0E4",
                    }}
                  >
                    No Data
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Modal >
    </Box >
  );
}

export default InitialInvoiceModal;
